(() => {
  'use strict';
  if (window.pigGoogleAdsInstalled) return;
  window.pigGoogleAdsInstalled = true;
  const tag = 'AW-18483863149';
  const destinations = {
    catering: tag + '/o-yPCM663I8dEO285e1E',
    orders: tag + '/MNUYCKXJ3I8dEO285e1E',
    phone: tag + '/2KrXCKjJ3I8dEO285e1E',
    directions: tag + '/g3VJCKvJ3I8dEO285e1E',
    page: tag + '/3C4mCNi2spAdEO285e1E',
    product: tag + '/wx29CNu2spAdEO285e1E'
  };
  let context = {};
  try {
    const node = document.getElementById('pig-tracking-context');
    if (node) context = JSON.parse(node.textContent);
  } catch (_) {}
  const ga4 = /^G-[A-Z0-9]+$/.test(context.ga4MeasurementId || '') ? context.ga4MeasurementId : '';
  const qa = new URLSearchParams(window.location.search).get('pig_qa') === '1';
  const pendingKey = 'pig-catering-pending-request';
  let marketingAllowed = false;
  let analyticsAllowed = false;
  let loaded = false;
  let adsConfigured = false;
  let ga4Configured = false;
  let quoteSent = false;
  const sent = new Set();
  const recorded = new Set();
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {
    ad_storage: 'denied', analytics_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied'
  });
  window.gtag('set', 'ads_data_redaction', true);
  // Google's linker decorates the existing dish deep link at click time.
  window.gtag('set', 'linker', { domains: ['pizzaitaliagrill.com', 'food.orders.co'] });

  const pageLocation = () => {
    const url = new URL(window.location.href);
    // Keep known attribution fields; omit arbitrary query strings and form data.
    const allowed = new Set(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'gclid', 'gbraid', 'wbraid', '_gl', 'variant', 'page']);
    for (const key of Array.from(url.searchParams.keys())) {
      if (!allowed.has(key)) url.searchParams.delete(key);
    }
    url.hash = '';
    return url.href;
  };
  const pageParams = () => ({
    page_location: pageLocation(), page_title: context.pageTitle || document.title || '',
    page_type: context.pageType || 'other', collection_handle: context.collectionHandle || ''
  });
  const record = (name, params = {}, once = '') => {
    if (!analyticsAllowed || (once && recorded.has(once))) return false;
    if (once) recorded.add(once);
    const detail = { event: 'pig_' + name, ...pageParams(), ...params };
    window.dataLayer.push(detail);
    if (ga4Configured && !qa) {
      window.gtag('event', name, { send_to: ga4, transport_type: 'beacon', ...pageParams(), ...params });
    }
    return true;
  };
  const pending = () => {
    try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); }
    catch (_) { return null; }
  };
  const conversion = (kind, extra = {}, once = '') => {
    if (!marketingAllowed || !adsConfigured || qa || (once && sent.has(once))) return false;
    if (once) sent.add(once);
    window.gtag('event', 'conversion', {
      send_to: destinations[kind], transport_type: 'beacon', ...extra
    });
    return true;
  };
  const pageEvents = () => {
    record('page_view', {}, 'page');
    conversion('page', {}, 'page');
    if (context.pageType === 'collection') {
      record('collection_view', { collection_name: context.collectionTitle || '' }, 'collection');
    }
    if (context.pageType === 'product' && context.product) {
      record('view_item', { items: [context.product], currency: context.currency || 'USD' }, 'product');
      conversion('product', {}, 'product');
    }
  };
  const acceptedQuote = () => {
    if (quoteSent || !document.querySelector('[data-pig-catering-success]')) return;
    const request = pending();
    if (!request || Date.now() - request.time > 3600000 || request.time > Date.now()) return;
    let tracked = false;
    if (analyticsAllowed && !request.analyticsSent && !request.qa) {
      record('generate_lead', { lead_type: 'catering_quote', request_id: request.id });
      request.analyticsSent = true;
      tracked = true;
    }
    if (marketingAllowed && !request.adsSent && !request.qa) {
      request.adsSent = conversion('catering', { transaction_id: request.id });
      tracked = tracked || request.adsSent;
    }
    if (request.qa) document.querySelector('[data-pig-catering-success]').setAttribute('data-pig-qa-tracking-verified', 'true');
    if (request.qa || (request.analyticsSent && request.adsSent)) {
      quoteSent = true;
      try { sessionStorage.removeItem(pendingKey); } catch (_) {}
    } else if (tracked) {
      try { sessionStorage.setItem(pendingKey, JSON.stringify(request)); } catch (_) {}
    }
  };
  const syncConsent = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    marketingAllowed = privacy.marketingAllowed() === true;
    analyticsAllowed = privacy.analyticsProcessingAllowed() === true;
    const sharing = privacy.saleOfDataAllowed() === true && navigator.globalPrivacyControl !== true;
    window.gtag('consent', 'update', {
      ad_storage: marketingAllowed ? 'granted' : 'denied',
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_user_data: marketingAllowed && sharing ? 'granted' : 'denied',
      ad_personalization: marketingAllowed && sharing ? 'granted' : 'denied'
    });
    if ((marketingAllowed || (analyticsAllowed && ga4)) && !loaded) {
      loaded = true;
      window.gtag('js', new Date());
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + (marketingAllowed ? tag : ga4);
      document.head.appendChild(script);
    }
    if (marketingAllowed && !adsConfigured) {
      adsConfigured = true;
      window.gtag('config', tag, { allow_ad_personalization_signals: sharing,
        page_location: pageLocation(), page_title: context.pageTitle || document.title || '' });
    }
    if (analyticsAllowed && ga4 && !ga4Configured) {
      ga4Configured = true;
      window.gtag('config', ga4, { send_page_view: false, page_location: pageLocation(),
        allow_google_signals: marketingAllowed && sharing,
        allow_ad_personalization_signals: marketingAllowed && sharing });
    }
    pageEvents();
    acceptedQuote();
  };
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('pig:catering-request-accepted', acceptedQuote);
  const beginQuote = () => {
    const id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ id, time: Date.now(), qa })); } catch (_) {}
  };
  document.addEventListener('pig:catering-request-started', beginQuote);
  document.addEventListener('submit', event => {
    if (event.target.matches('.pig-catering__form') && event.target.checkValidity()) beginQuote();
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.hostname === 'food.orders.co' && /^\/j04tjxem\/menu(?:\/|$)/.test(url.pathname)) {
      const card = link.closest('[data-js-product-item]');
      const itemTitle = card && card.querySelector('.product-item__title');
      const product = url.searchParams.has('itemId') ? (card ? {
        item_id: card.id.replace('product-item-', ''),
        item_name: itemTitle ? (itemTitle.getAttribute('title') || itemTitle.textContent.trim()) : ''
      } : (context.product || {})) : {};
      record('order_now_click', { shopify_product_id: product.item_id || '',
        product_name: product.item_name || '', orders_item_id: url.searchParams.get('itemId') || '',
        link_url: url.origin + url.pathname + (url.searchParams.has('itemId') ? '?itemId=' + encodeURIComponent(url.searchParams.get('itemId')) : '') });
      conversion('orders');
    } else if (url.protocol === 'tel:') {
      record('phone_click'); conversion('phone');
    } else if (link.hasAttribute('data-pig-directions') ||
      (/^(www\.)?google\.com$/.test(url.hostname) && url.pathname.startsWith('/maps') && (url.searchParams.has('destination') || url.searchParams.has('daddr')))) {
      record('directions_click'); conversion('directions');
    }
  }, true);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
})();
